import { render, staticRenderFns } from "./AdminSectionContainer.vue?vue&type=template&id=fce2e2d8&"
import script from "./AdminSectionContainer.vue?vue&type=script&lang=js&"
export * from "./AdminSectionContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports